export const emailNotifications = ["News and updates"];
